import React from 'react'
import PropTypes from 'prop-types'
import { Select } from '@michelin/acid-components'

class MaterialSelectable extends React.Component {
	constructor(props) {
		super(props)

		this.state = { hasError: false }
	}

	componentDidCatch(error, info) {
		this.setState({ hasError: true })
	}

	render() {
		const { classes, options, errorMessage, code, description, ...otherProps } = this.props

		return (
			<Select
				{...otherProps}
				required
				fullWidth
				helperText={errorMessage}
				options={options.map(item => ({ label: description ? item[description] : item.name, value: code ? item[code] : item.id }))}
				style={{ minWidth: '50px' }} />
		)
	}
}

MaterialSelectable.propTypes = {
	classes: PropTypes.object,
	name: PropTypes.string.isRequired,
	label: PropTypes.string,
	value: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number,
		PropTypes.bool,
		PropTypes.array,
	]).isRequired,
	options: PropTypes.array.isRequired,
	placeholder: PropTypes.string,
	autoFocus: PropTypes.bool,
	disabled: PropTypes.bool,
	required: PropTypes.bool,
	error: PropTypes.bool,
	errorMessage: PropTypes.string,
	onChange: PropTypes.func,
	onBlur: PropTypes.func,
	code: PropTypes.string,
	description: PropTypes.string,
	InputLabelProps: PropTypes.object
}

MaterialSelectable.defaultProps = {
	value: '',
	label: '',
	autoFocus: false,
	disabled: false,
	required: false,
	error: false,
	errorMessage: '',
	code: 'id',
	description: 'name',
}

export default MaterialSelectable



// WEBPACK FOOTER //
// ./src/components/MaterialSelectable.js